import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { BehaviorSubject, from, Observable, throwError,firstValueFrom } from 'rxjs';
import { catchError, filter, switchMap, take, takeLast, tap,map } from 'rxjs/operators';
import { GoService } from './go-service';
import { AuthService, UserProfile } from './auth-service';
import { ResultVO } from './vo/CommonVO';


// TODO: user jwt token service
@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {

    private isRefreshing: boolean = false;

    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    private duplicateLoginSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(
        private toastCtrl: ToastController,
        private goService: GoService,
        private authService: AuthService

    ) { }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log("................HttpInterceptor...............");

        return from(this.authService.getUserProfile()).pipe(
            switchMap(profile => {
                console.log("................switchMap..............." + request);
                if (profile && profile.accessToken) {
                    console.log("................profile..............." + profile.accessToken);
                    if (request) {
                        request = this.addHeaderToken(request, profile.accessToken);
                    }

                    return next.handle(request).pipe(
                        catchError(error => {
                          
                            if (error instanceof HttpErrorResponse && error.status === 401) {
                                console.log(">>>>>>發生401進行後續處理，執行refresh token 交換")
                                return this.error401Handler(profile.userId, request, next);
                            }else{
                                alert("發生錯誤:" + JSON.stringify(error));
                            }

                        })
                    )
                } else {
                    return next.handle(request);
                }
                // return next.handle(request).pipe(
                //     catchError(error => {
                //         alert("發生錯誤:" + JSON.stringify(error));
                //         if (error instanceof HttpErrorResponse && error.status === 401) {
                //             return this.error401Handler(request, next);
                //         }
                //         //   if (error instanceof HttpErrorResponse && error.status === 409) {
                //         //     return from(this.error409Handler(request, next));
                //         //   }

                //         throwError(() => error);
                //     })
                // );
            }),
            catchError(error => {
                console.log("jwt is null" + error);
                return next.handle(request);
            }))
    }

    //   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     return from(this.interceptHandler(req, next));
    //   }

    //   async interceptHandler(req: HttpRequest<any>, next: HttpHandler) {
    //     let request = req;

    //     const isLoggedin = await this.authService.isLogin$.pipe(
    //       take(1)
    //     ).toPromise();

    //     if (isLoggedin === true) {
    //       const token = await this.authService.jwtToken.pipe(
    //         take(1)
    //       ).toPromise();
    //       request = this.addHeaderToken(request, token, this.authService.sessionId);
    //     }

    //     return next.handle(request)
    //       .pipe(
    //         catchError((error) => {
    //           console.log(this.authService.duplicatedLogin);
    //           console.error(error);

    //           if (error instanceof HttpErrorResponse && error.status === 401) {
    //             return this.error401Handler(request, next);
    //           }
    //           if (error instanceof HttpErrorResponse && error.status === 409) {
    //             return from(this.error409Handler(request, next));
    //           }

    //           return throwError(error);
    //         }),
    //       ).toPromise();
    //   }

    private addHeaderToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            },
        });
    }


    /**
 * Token 過期
 */
    private error401Handler(userId: string, request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.isRefreshing === true) {
            console.log('已有請求正在處理 token 更新');
            return this.refreshTokenSubject.pipe(
                filter((token) => token !== null),
                takeLast(1),
                switchMap(() => {
                    return next.handle(request);
                })
            );
        }
        else {
            console.log("<<<<<<<<request:" + request);
            return this.authService.refreshJwtToken(userId).pipe(
                tap(async f=>{
                    console.log(f);
                    let profile  =  await firstValueFrom<UserProfile>(from(this.authService.getUserProfile()));
                    profile.accessToken =  f["data"]["accessToken"];
                    profile.refreshToken =f["data"]["refreshToken"];
                    await from(this.authService.setUserPrfolie(profile));
                }),
                map(dd=>({data:dd.data,req:request})),
                switchMap((rr) => {
                    console.log("<<<<<<<<request2:" + request);
                    console.log(">>>>>>>>>>>>>>>>>>>>>debbug:"+JSON.stringify(rr));
                    let accessToken = rr["data"]["accessToken"];
                    let refreshToken = rr["data"]["refreshToken"];
                    let req =  rr["req"];
                     console.log(">>>>>>>>>>>>>>>>>>>>>交換後再送出" + accessToken + ":" + req);
                     var request = this.addHeaderToken(req, accessToken);
                    return next.handle(request);
                })

                // switchMap(rr=> {

                //     console.log(">>>>>>>>>>>>>>>>>>>>>aaaa"+JSON.stringify(rr));

                //     return(from(this.authService.getUserProfile())).pipe(
                //         switchMap((p)=>{
                //             p.accessToken = rr.data["accessToken"];
                //             p.refreshToken =  rr.data["refreshToken"];

                //             //TODO儲存至storge
                //             console.log(">>>>>>>>>>>>>>>>>>>>>交換後再送出"+rr.data["accessToken"]+":"+request);
                //             var request = this.addHeaderToken(request,rr.data["accessToken"]);
                //             return next.handle(request);
                //         } )
                //     )
                //    // var profile = await this.authService.getUserProfile();            
                // })
            );

        }
    }

    /**
     * Token 過期
     */
    //   private error401Handler(request: HttpRequest<any>, next: HttpHandler) {
    //     if (this.isRefreshing === true) {
    //       console.log('已有請求正在處理 token 更新');
    //       return this.refreshTokenSubject.pipe(
    //         filter((token) => token !== null),
    //         takeLast(1),
    //         switchMap(() => {
    //           return next.handle(request);
    //         })
    //       );
    //     } else {
    //       this.isRefreshing = true;
    //       this.refreshTokenSubject.next(null);
    //       console.log('開始處理 token 更新');

    //       return this.authService.refreshJwtToken().pipe(
    //         tap(() => {
    //           console.log('run refreshToken action....');
    //         }),
    //         catchError(async (error) => {
    //           this.isRefreshing = false;
    //           this.duplicateLoginSubject.error('RefreshToken is invalid');

    //           if (error instanceof HttpErrorResponse && error.status === 403 && error.statusText == 'RefreshToken is invalid') {
    //             // authService 移除登入資訊
    //             await this.authService.userLogOut();

    //             const toast = await this.toastCtrl.create({
    //               color: 'danger',
    //               message: '由於閒置過久，請重新登入',
    //               duration: 3000,
    //             });
    //             toast.present();
    //         }
    //             // 開啟 login modal
    //             await this.appService.openLoginModal();
    //           } else {
    //             console.log(error.message);
    //             return next.handle(request);
    //           }
    //         }),
    //         switchMap((token: JWToken) => {
    //           this.isRefreshing = false;
    //           console.log('>>>>>> 執行 refresh 交換 token');
    //           this.refreshTokenSubject.next(token.jwt);
    //           return next.handle(this.addHeaderToken(request, token.jwt, this.authService.sessionId));
    //         }),
    //       );
    //     }
    //   }

    //   /**
    //    * 帳號重複登入
    //    */
    //   private async error409Handler(request: HttpRequest<any>, next: HttpHandler) {
    //     // console.log(request);
    //     console.log(this.authService.duplicatedLogin);
    //     if (this.authService.duplicatedLogin === false) {
    //       await this.authService.setDuplicatedLogin(true);
    //       this.duplicateLoginSubject.next(true);
    //       this.authService.purgeAuth();
    //       const toast = await this.toastCtrl.create({
    //         color: 'danger',
    //         message: '此帳號已於其他裝置登入，若要繼續請重新登入',
    //         duration: 3000,
    //       });

    //       toast.present();

    //       // authService 移除登入資訊
    //       // this.authService.userLogOut();

    //       // 開啟 login modal
    //       const login = await this.appService.openLoginModal();
    //       console.log(login);

    //       return next.handle(request).toPromise();
    //     } else {
    //       console.log('>>>>>>> 進行重覆丟棄');
    //       return this.duplicateLoginSubject.pipe(
    //         filter((isDupLogin) => isDupLogin === true),
    //         takeLast(1),
    //         switchMap((data) => {
    //           this.authService.setDuplicatedLogin(false);
    //           return next.handle(request).toPromise();
    //         }),
    //       ).toPromise();
    //     }
    //   }
}
